import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowToBottomBlue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 14"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M10.875 6.281 6.25 10.906a.36.36 0 0 1-.531 0L1.094 6.281c-.157-.156-.157-.406 0-.531l.625-.625c.125-.156.375-.156.531 0l2.906 3.031V.375c0-.187.188-.375.375-.375h.875a.38.38 0 0 1 .375.375v7.781L9.72 5.125c.156-.156.406-.156.531 0l.625.625c.156.125.156.375 0 .531m.75 6.094c.188 0 .375.188.375.375v.875a.38.38 0 0 1-.375.375H.375A.36.36 0 0 1 0 13.625v-.875a.38.38 0 0 1 .375-.375z"
    />
  </svg>
);
export default SvgArrowToBottomBlue;
